import { useEffect, useRef } from "react";

export const NetworkBackground = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const context = canvas.getContext("2d");
    if (!context) return;

    let animationFrame = 0;
    let width = 0;
    let height = 0;
    const particles = Array.from({ length: 54 }, () => ({ x: Math.random(), y: Math.random(), vx: (Math.random() - 0.5) * 0.00035, vy: (Math.random() - 0.5) * 0.00035 }));

    const resize = () => {
      width = canvas.offsetWidth * window.devicePixelRatio;
      height = canvas.offsetHeight * window.devicePixelRatio;
      canvas.width = width;
      canvas.height = height;
    };

    const draw = () => {
      context.clearRect(0, 0, width, height);
      context.strokeStyle = "rgba(0, 212, 255, 0.13)";
      context.fillStyle = "rgba(0, 212, 255, 0.38)";
      context.lineWidth = 1;

      particles.forEach((particle) => {
        particle.x += particle.vx;
        particle.y += particle.vy;
        if (particle.x < 0 || particle.x > 1) particle.vx *= -1;
        if (particle.y < 0 || particle.y > 1) particle.vy *= -1;
      });

      particles.forEach((particle, index) => {
        const x = particle.x * width;
        const y = particle.y * height;
        context.beginPath();
        context.arc(x, y, 2.4 * window.devicePixelRatio, 0, Math.PI * 2);
        context.fill();

        for (let otherIndex = index + 1; otherIndex < particles.length; otherIndex++) {
          const other = particles[otherIndex];
          const otherX = other.x * width;
          const otherY = other.y * height;
          const distance = Math.hypot(x - otherX, y - otherY);
          if (distance < 190 * window.devicePixelRatio) {
            context.globalAlpha = Math.max(0, 1 - distance / (190 * window.devicePixelRatio));
            context.beginPath();
            context.moveTo(x, y);
            context.lineTo(otherX, otherY);
            context.stroke();
            context.globalAlpha = 1;
          }
        }
      });

      animationFrame = requestAnimationFrame(draw);
    };

    resize();
    draw();
    window.addEventListener("resize", resize);

    return () => {
      cancelAnimationFrame(animationFrame);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={canvasRef} className="absolute inset-0 h-full w-full opacity-70" aria-hidden="true" />;
};
